/**
 * lucide-react v0.209.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const ArrowLeftFromLine = createLucideIcon("ArrowLeftFromLine", [
  ["line", { x1: "3", x2: "17", y1: "12", y2: "12", key: "10k5p2" }],
  ["polyline", { points: "9 6 3 12 9 18", key: "biqh3b" }],
  ["path", { d: "M21 19V5", key: "b4bplr" }]
]);

export { ArrowLeftFromLine as default };
//# sourceMappingURL=arrow-left-from-line.js.map
